import { OPEN_SNACK, CLOSE_SNACK } from "store/const/actionTypes";
export function closeSnack() {
  return { type: CLOSE_SNACK };
}

export function openSnack(snackType, message) {
  return { type: OPEN_SNACK, message, snackType };
}
